import classnames from 'classnames';
import cookies from 'js-cookie';
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import to from 'await-to-js';
import { graphql, useStaticQuery } from 'gatsby';
import { useSetState } from 'react-use';


import AssessmentForm from 'organisms/AssessmentForm';
import Button from 'molecules/Button';
import Checkbox from 'molecules/Checkbox';
import Form, { WrappedForm } from 'organisms/Form';
import HTML from 'molecules/HTML';
import Image from 'molecules/Image';
import Input from 'molecules/Input';
import MaskedInput from 'molecules/MaskedInput';
import Modal from 'molecules/Modal';
import Radio from 'molecules/Radio';
import Select from 'molecules/Select';
import { buildSelectOptions } from 'lib/helpers';


import tempImg from '~static/images/holding-drone.jpg';

import './AssessmentMultiStep.scss';



/**
 * Assessment.
 */
const propTypes = {
  inPopup: PropTypes.bool,
  handleClose: PropTypes.func,
}
const AssessmentMultiStep = React.memo( p => {

  const [ s, setState ] = useSetState( {
    currentStep: 1,
    isCompleted: false,
    email: null,
  } );
  s.setState = setState;

  const { sfPicklist: { pilotTypeOptions } } = useStaticQuery( graphql`
    query AssessmentMultiStep1Query {
      sfPicklist {
        pilotTypeOptions {
          label
          value
        }
      }
    }
  ` );
  const typeOptions = buildSelectOptions( {
    items:      pilotTypeOptions,
    valueKey:   'value',
    contentKey: 'label',
    selectText: 'How do you plan to use your drone?',
  } );

  /* ------ = Output. = --------------------------------------------------------------------- */
  const className = classnames(
    'AsmtMulti',
    p.className,
    {
      'in-popup': !! p.inPopup,
    }
  );

  return(

    <div className={ className }>

      { do {

        if( s.currentStep === 1 ) {

          return(

            <div className="AsmtMulti__step1 row">

              <Image
              className="col-md-5"
              src={ tempImg }
              />
              <div className="AsmtMulti__content col-md-7">
                <div className="inner">

                  <h2 className="AsmtMulti__content-hline h-xl">
                    Get a free personalized recommendation on <strong>equipment, training, and regulations!</strong>
                  </h2>

                  <p>Just complete a short 2 minute assessment and we will email specific recommendations tailored to you.</p>

                  { /*}<p>
                    Complete a free personalized assessment for <strong>recommendations on equipment, training, and regulations specifically tailored to you!</strong>
                  </p>
                  */ }

                  <div className="AsmtMulti__content-form">

                    <WrappedForm
                    memo={ null }
                    withLabels={ false }
                    form={ formProps => {

                      const { getFieldDecorator } = formProps.form;
                      const [ formState, setFormState ] = useSetState( {
                        isProcessing: false,
                      } );

                      const handleSubmit = async e => {
                        e.preventDefault();

                        formProps.form.validateFields( async ( errors, values ) => {

                          // Uh oh...
                          if( errors ) {
                            return;
                            // return setformState( {
                            //   isProcessing: false,
                            // } );
                          }
                          setFormState( {
                            isProcessing: true,
                          } );

                          // Proceed to next step.
                          setTimeout( () => {

                            setState( {
                              currentStep: 2,
                              email: values.Email,
                            } );

                          }, 500 )


                          // Submit initial info to sf (async).
                          const [ err, response ] = axios.post( `${window.FUNCTIONS_URL}/sf-submit-form`,
                            {
                              ...values,
                              FirstName: 'unknown',
                              LastName: 'unknown',
                              Most_Recent_Lead_Source__c: 'Website Promo',
                              Most_Recent_Lead_Source_Specific__c: 'Assessment Popup Step 1',
                              Most_Recent_Lead_Source_URL__c: window.location.href,
                              Ad_Source__c: cookies.get( 'adsource' ),
                            },
                            {
                              headers: {
                                'Content-Type': 'application/json',
                              }
                            }
                          )
                          .catch( err => console.warn( err ) );

                        } );

                      }


                      return(

                        <Form onSubmit={ handleSubmit }>

                          <Form.Item>
                            { getFieldDecorator( 'Email', {
                              rules: [ {
                                required: true,
                                type: 'email',
                                message: 'Please enter your email.',
                              } ],
                            } )(
                              <Input
                              placeholder="Email"
                              />
                            ) }
                          </Form.Item>

                          <Form.Item>
                            { getFieldDecorator( 'Pilot_Type__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a pilot type.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select
                              onChange={ type => setState( { pilotType: type } ) }
                              >
                                { typeOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <div
                          className="AsmtMulti__content-btns"
                          style={ { marginTop: '0.5rem' } }
                          >

                            <div className="btn yes">
                              <Button
                              htmlType="submit"
                              size={ ! p.inPopup ? 'lg' : 'md' }
                              isBusy={ formState.isProcessing }
                              style={ { width: '100%' } }
                              >
                                Continue to my assessment
                              </Button>

                            </div>

                            { p.inPopup &&
                              <div className="btn no">
                                <button onClick={ p.handleClose }>
                                  No thanks, I have everything I need
                                </button>
                              </div>
                            }

                          </div>

                        </Form>

                      )

                    } }
                    />

                </div>
              </div>

              </div>

            </div>

          );
        }
        else if( s.currentStep === 2 ) {

          return(

            <div className="AsmtMulti__step 2">

              <div className="inner">

                <h2
                className="AsmtMulti__content-hline h-md"
                style={ { textAlign: 'center' } }
                >
                  To better support you and your career goals, we can tailor the drone information that you will receive
                </h2>


                <div className="AsmtMulti__step2-form">

                  <AssessmentForm
                  parentState={ s }
                  Most_Recent_Lead_Source_Specific__c="Assessment Popup Step 2"
                  />


                </div>

              </div>

            </div>

          );
        }

      } }

    </div>

  )

} );
AssessmentMultiStep.propTypes = propTypes;

export default AssessmentMultiStep;
